/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_PaymentInputs */

const en_safe_payment = /** @type {(inputs: Safe_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safe payment`)
};

const th_safe_payment = /** @type {(inputs: Safe_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชำระเงินปลอดภัย`)
};

const ja_safe_payment = /** @type {(inputs: Safe_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全なお支払い`)
};

const fr_safe_payment = /** @type {(inputs: Safe_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement sécurisé`)
};

const es_safe_payment = /** @type {(inputs: Safe_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago seguro`)
};

const ru_safe_payment = /** @type {(inputs: Safe_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасная оплата`)
};

const zh_safe_payment = /** @type {(inputs: Safe_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全支付`)
};

const vi_safe_payment = /** @type {(inputs: Safe_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán an toàn`)
};

/**
* | output |
* | --- |
* | "Safe payment" |
*
* @param {Safe_PaymentInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const safe_payment = /** @type {((inputs?: Safe_PaymentInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_PaymentInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_safe_payment(inputs)
	if (locale === "ja") return ja_safe_payment(inputs)
	if (locale === "fr") return fr_safe_payment(inputs)
	if (locale === "es") return es_safe_payment(inputs)
	if (locale === "ru") return ru_safe_payment(inputs)
	if (locale === "zh") return zh_safe_payment(inputs)
	if (locale === "vi") return vi_safe_payment(inputs)
	return en_safe_payment(inputs)
});